import {NatureAvance} from "./nature-avance";
import {ListItem} from "../common/list-view/list-item";

/**
 * Modèle d'une avance imputable
 *
 * @author Laurent Convert
 * @date 23/04/2026
 */
export class AvanceImputable implements ListItem {
	/** Identifiant de l'avance */
	idAvance: number;

	/** Libellé de l'avance */
	libelleObjet: string;

	/** Identifiant de l'OD (peut être null) */
	idOd: number;

	/** Nature de l'avance (Espèce / Virement) */
	nature: NatureAvance;

	/** Montant disponible */
	montant: number;

	/** Devise */
	devise: string;

	/** Taux */
	taux: number;

	/** Indicateur de sélection (front-only) */
	isSelected: boolean;

	/**
	 * Constructeur
	 */
	constructor(dto: any) {
		if (dto) {
			Object.assign(this,dto);
		}
	}

	getKey(): number {
		return this.idAvance;
	}
}